const funtabsData = {
	model: "",
	widthNum: 160,
	heightNum: 64,
	gridWidthNum: 1314,
	radius: 12,
	gap: 24,
	cardStyle: "defaultCard",
	tabsActiveKey: 0,
	backgroundImage: "/images/wallpaper.JPG",
	content: [
		{
			label: "首页",
			key: 0,
			content: [
				{
					label: "便捷记事本",
					type: "note",
					link: null,
					size: null,
					x: "80",
					y: "20",
					icon: null,
					backgroundColor: null,
					id: 0,
				},
				{
					label: "实时热榜",
					type: "hotEventList",
					link: null,
					size: null,
					x: null,
					y: null,
					icon: null,
					backgroundColor: null,
					id: 1,
				},
				{
					label: "Github",
					type: "link",
					link: "https://github.com/",
					size: 11,
					x: "80",
					y: "20",
					icon: "https://oss.funtabs.cn/icon/github.svg",
					backgroundColor: "#FF6900",
					id: 4,
				},
				{
					label: "AIWeb",
					type: "link",
					link: "https://chat.fsfst.com/",
					size: 11,
					x: "80",
					y: "20",
					icon: "https://oss.funtabs.cn/icon/weibo.svg",
					backgroundColor: "#ffffff",
					id: 6,
				},
				{
					label: "cloudflare",
					type: "link",
					link: "https://www.cloudflare.com/",
					size: 11,
					x: "80",
					y: "20",
					icon: "https://oss.funtabs.cn/icon/douyin.svg",
					backgroundColor: "#000000",
					id: 7,
				},
				{
					label: "阿里云",
					type: "link",
					link: "https://aliyun.com",
					size: 11,
					x: "80",
					y: "20",
					icon: "https://oss.funtabs.cn/icon/aliyun.svg",
					backgroundColor: "#CB0507",
					id: 17,
				},
				{
					label: "腾讯云",
					type: "link",
					link: "https://cloud.tencent.com/",
					size: 11,
					x: "80",
					y: "20",
					icon: "https://oss.funtabs.cn/icon/qqvideo.svg",
					backgroundColor: null,
					id: 9,
				},
				{
					label: "Youtube",
					type: "link",
					link: "https://www.youtube.com/",
					size: 11,
					x: "80",
					y: "20",
					icon: "https://oss.funtabs.cn/icon/iqiyi.svg",
					backgroundColor: "#00cc4c",
					id: 8,
				},
				{
					label: "OSS Insight",
					type: "link",
					link: "https://ossinsight.io",
					size: 11,
					x: "80",
					y: "20",
					icon: "https://oss.funtabs.cn/icon/youku.svg",
					backgroundColor: null,
					id: 10,
				},
				
			],
		},
		{
			label: "设计灵感",
			key: 1,
			content: [
				{
					label: "阿里矢量图库",
					type: "link",
					link: "https://iconfont.cn",
					size: 11,
					x: "80",
					y: "20",
					icon: "https://img.alicdn.com/imgextra/i4/O1CN01Z5paLz1O0zuCC7osS_!!6000000001644-55-tps-83-82.svg",
					backgroundColor: null,
					id: 12,
				},
				{
					label: "Sketch素材",
					type: "link",
					link: "https://oursketch.com",
					size: 11,
					x: "80",
					y: "20",
					icon: "https://oss.funtabs.cn/icon/sketch.svg",
					backgroundColor: null,
					id: 13,
				},
				{
					label: "app应用设计示例",
					type: "link",
					link: "https://screenlane.com/",
					size: 11,
					x: "80",
					y: "20",
					icon: "https://oss.funtabs.cn/icon/screenlane.svg",
					backgroundColor: null,
					id: 14,
				},
				{
					label: "imgTools",
					type: "link",
					link: "https://imagestool.com/zh_CN/",
					size: 11,
					x: "80",
					y: "20",
					icon: "https://oss.funtabs.cn/icon/img.svg",
					backgroundColor: null,
					id: 15,
				},
				{
					label: "在线抠图",
					type: "link",
					link: "https://www.remove.bg/zh",
					size: 11,
					x: "80",
					y: "20",
					icon: "https://oss.funtabs.cn/icon/removeBg.svg",
					backgroundColor: null,
					id: 16,
				},
			],
		},
		{
			label: "程序代码",
			key: 2,
			content: [
				{
					label: "Github",
					type: "link",
					link: "https://github.com",
					size: 11,
					x: "80",
					y: "20",
					icon: "https://oss.funtabs.cn/icon/juejin.svg",
					backgroundColor: "#2080ff",
					id: 18,
				},
				{
					label: "腾讯云",
					type: "link",
					link: "https://cloud.tencent.com/",
					size: 11,
					x: "80",
					y: "20",
					icon: "https://oss.funtabs.cn/icon/juejin.svg",
					backgroundColor: "#2080ff",
					id: 20,
				},
				{
					label: "阿里云",
					type: "link",
					link: "https://aliyun.com/",
					size: 11,
					x: "80",
					y: "20",
					icon: "https://oss.funtabs.cn/icon/juejin.svg",
					backgroundColor: "#2080ff",
					id: 20,
				},
				{
					label: "雨云",
					type: "link",
					link: "https://www.rainyun.com/MTA5NDgz_",
					size: 11,
					x: "80",
					y: "20",
					icon: "https://oss.funtabs.cn/icon/juejin.svg",
					backgroundColor: "#2080ff",
					id: 20,
				},
				{
					label: "红杏云",
					type: "link",
					link: "https://hongxingdl.com/",
					size: 11,
					x: "80",
					y: "20",
					icon: "https://oss.funtabs.cn/icon/juejin.svg",
					backgroundColor: "#2080ff",
					id: 20,
				},
				{
					label: "Cloudflare",
					type: "link",
					link: "https://dash.cloudflare.com/",
					size: 11,
					x: "80",
					y: "20",
					icon: "https://oss.funtabs.cn/icon/juejin.svg",
					backgroundColor: "#2080ff",
					id: 20,
				},
				{
					label: "稀土掘金",
					type: "link",
					link: "https://juejin.cn",
					size: 11,
					x: "80",
					y: "20",
					icon: "https://oss.funtabs.cn/icon/juejin.svg",
					backgroundColor: "#2080ff",
					id: 20,
				},
			],
		},
		{
			label: "电商平台",
			key: 3,
			content: [
				{
					label: "PingPong",
					type: "link",
					link: "https://us.pingpongx.com/dashboard/account",
					size: 11,
					x: "80",
					y: "20",
					icon: "https://oss.funtabs.cn/icon/github.svg",
					backgroundColor: null,
					id: 18,
				},
				{
					label: "跨境巴士",
					type: "link",
					link: "https://www.kuajing84.com/index/login/login.html",
					size: 11,
					x: "80",
					y: "20",
					icon: "https://oss.funtabs.cn/icon/github.svg",
					backgroundColor: null,
					id: 18,
				},
				{
					label: "快手小店",
					type: "link",
					link: "https://s.kwaixiaodian.com/zone/goods/v1/list",
					size: 11,
					x: "80",
					y: "20",
					icon: "https://oss.funtabs.cn/icon/github.svg",
					backgroundColor: null,
					id: 18,
				},
				{
					label: "抖音小店",
					type: "link",
					link: "https://fxg.jinritemai.com/ffa/mshop/homepage/index",
					size: 11,
					x: "80",
					y: "20",
					icon: "https://oss.funtabs.cn/icon/github.svg",
					backgroundColor: null,
					id: 18,
				},
				{
					label: "Ozon",
					type: "link",
					link: "https://seller.ozon.ru/app/dashboard/main?__rr=1",
					size: 11,
					x: "80",
					y: "20",
					icon: "https://oss.funtabs.cn/icon/github.svg",
					backgroundColor: null,
					id: 18,
				},
				{
					label: "Shoppaas",
					type: "link",
					link: "https://www.shoppaas.com/",
					size: 11,
					x: "80",
					y: "20",
					icon: "https://oss.funtabs.cn/icon/github.svg",
					backgroundColor: null,
					id: 18,
				},
				{
					label: "独立柱123",
					type: "link",
					link: "https://www.dlz123.cn/",
					size: 11,
					x: "80",
					y: "20",
					icon: "https://oss.funtabs.cn/icon/github.svg",
					backgroundColor: null,
					id: 18,
				},
				{
					label: "Paypal",
					type: "link",
					link: "https://www.paypal.com/",
					size: 11,
					x: "80",
					y: "20",
					icon: "https://oss.funtabs.cn/icon/github.svg",
					backgroundColor: null,
					id: 18,
				},
				{
					label: "Spyfu",
					type: "link",
					link: "https://www.spyfu.com/",
					size: 11,
					x: "80",
					y: "20",
					icon: "https://oss.funtabs.cn/icon/github.svg",
					backgroundColor: null,
					id: 18,
				},
				{
					label: "Google趋势",
					type: "link",
					link: "https://trends.google.com/trends/",
					size: 11,
					x: "80",
					y: "20",
					icon: "https://oss.funtabs.cn/icon/github.svg",
					backgroundColor: null,
					id: 18,
				},
				{
					label: "Wildberries",
					type: "link",
					link: "https://seller-auth.wildberries.ru/",
					size: 11,
					x: "80",
					y: "20",
					icon: "https://oss.funtabs.cn/icon/github.svg",
					backgroundColor: null,
					id: 18,
				},
				{
					label: "万里汇",
					type: "link",
					link: "https://portal.worldfirst.com.cn/",
					size: 11,
					x: "80",
					y: "20",
					icon: "https://oss.funtabs.cn/icon/github.svg",
					backgroundColor: null,
					id: 18,
				},
			],
		},
	],
};

export { funtabsData };
